import styled from 'styled-components';
const BaseSelectListItem = styled.li `
  display: flex;
  justify-content: space-between;

  padding: 8px 16px;
  line-height: 22px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  :hover {
    text-decoration: none;
    background: ${({ theme }) => theme.colors.ui03};
  }
`;
export default BaseSelectListItem;
//# sourceMappingURL=BaseInputSelectListItem.js.map